import {
  CLOSE_TOPIC_DIALOG,
  OPEN_TOPIC_DIALOG,
  SET_TOPIC_DIALOG_STATE,
  TOPIC_VALID_FORM,
  TOPIC_INVALID_FORM,
  TOPIC_SUBMIT_INIT,
  TOPIC_SUBMIT_SUCCESS,
  SET_TOPIC_DELETE_DIALOG_STATE,
  TOPIC_NAME_HASNT_ERROR,
  TOPIC_NAME_ERROR,
  OPEN_ADD_SUBSCRIBERS,
  CLOSE_ADD_SUBSCRIBERS,
  SET_SUBSCRIBERS_TOPICS,
  GET_TOPIC_DETAIL,
} from '../constants/topic-constants'

const initialState = {
  isOpenTopicDialog: false,
  dialogState: {},
  topicNameErr: false,
  isTopicFormValid: null,
  isSubmitting: null,
  deleteDialogState: {},
  isOpenAddSubscribers: false,
  subscriberTopics: [],
}

const topicReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOPIC_DIALOG_STATE:
      return {
        ...state,
        dialogState: action.payload,
      }

    case SET_TOPIC_DELETE_DIALOG_STATE:
      return {
        ...state,
        deleteDialogState: action.payload,
      }

    case OPEN_TOPIC_DIALOG:
      return {
        ...state,
        isOpenTopicDialog: true,
      }

    case CLOSE_TOPIC_DIALOG:
      return {
        ...state,
        isOpenTopicDialog: false,
      }

    case TOPIC_VALID_FORM:
      return {
        ...state,
        isTopicFormValid: true,
        topicNameErr: false,
      }

    case TOPIC_INVALID_FORM:
      return {
        ...state,
        isTopicFormValid: false,
      }

    case TOPIC_SUBMIT_INIT:
      return {
        ...state,
        isSubmitting: true,
      }

    case TOPIC_SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      }

    case TOPIC_NAME_HASNT_ERROR:
      return {
        ...state,
        topicNameErr: false,
      }
    case TOPIC_NAME_ERROR:
      return {
        ...state,
        topicNameErr: true,
      }
    case OPEN_ADD_SUBSCRIBERS:
      return {
        ...state,
        isOpenAddSubscribers: true,
      }
    case CLOSE_ADD_SUBSCRIBERS:
      return {
        ...state,
        isOpenAddSubscribers: false,
      }
    case SET_SUBSCRIBERS_TOPICS:
      return {
        ...state,
        subscriberTopics: action.payload,
      }
    case GET_TOPIC_DETAIL:
      return {
        ...state,
        dialogState: { ...state.dialogState, ...action.payload },
      }
    default:
      return state
  }
}

export default topicReducer
